export const getNotificationProvider = state => state.notification;
